import * as React from "react";

const AdminUser = (props) => (
    <svg
        width={68}
        height={76}
        viewBox="0 0 68 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={34} cy={34} r={33} fill="white" />
        <circle cx={34} cy={34} r={30} fill="#DBE5EE" />
        <path
            d="M55.5 55L51 60L46.5 62.5C49.5 54.5 39.4 50.4 39 50C38.6 49.6 37.5 46 37.5 43C36.5 43.1667 33.3394 38.5762 35.5 38C43 36 40.8333 30.5 40.5 25.5C40.1667 25.5 38.6 25.3 35 24.5C31.4 23.7 29.1667 19.8333 28.5 18L29 16.5L37 15L41.5 17.5L44 24L44.5 25.5V35.5L43 39L41 41.5V45L42.5 47.5L47 48L52 49.5L55.5 55Z"
            fill="white"
        />
        <path
            d="M41 41.5C41.0001 43.5792 40.4496 47.7663 44.109 48.099C48.6833 48.5148 53.2574 48.099 54.505 55.1683"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M29.1386 41.4456C29.1386 43.5248 29.4713 47.7663 25.8119 48.099C21.2376 48.5149 16.2475 48.099 15 56"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M44.7724 29.802C44.7724 33.6325 44.1544 36.9355 42.6469 39.2544C41.1887 41.4973 38.8204 42.9406 34.9605 42.9406C31.3236 42.9406 28.9412 41.5082 27.4223 39.2426C25.8625 36.916 25.1486 33.6084 25.1486 29.802C25.1486 25.9756 25.7645 22.2219 27.3085 19.4609C28.8146 16.7678 31.2023 15 34.9605 15C37.8671 15 39.9227 16.0553 41.392 17.7203C42.8915 19.4193 43.8374 21.8216 44.3361 24.5743C44.6393 26.2471 44.7724 28.0231 44.7724 29.802Z"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M31 36C31 36 31.8889 38 35 38C38.1111 38 39 36 39 36"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M27.4753 47.2673C27.4753 47.2673 29.1387 50.5941 34.9605 50.5941M42.4456 47.2673C42.4456 47.2673 40.7823 50.5941 34.9605 50.5941M34.9605 50.5941V55.1683"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M44.1089 35.6238C44.1089 35.6238 47.4356 35.6242 47.4357 31.7075C47.4357 27.7908 45.1069 28.1471 45.1069 28.1471"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M25.8119 35.6238C25.8119 35.6238 22.4852 35.6242 22.4852 31.7075C22.4852 27.7908 24.8139 28.1471 24.8139 28.1471"
            stroke="#333F50"
            strokeWidth={2}
        />
        <circle cx={34} cy={34} r={33} stroke="#333F50" strokeWidth={2} />
        <circle
            cx={35}
            cy={63}
            r={12}
            fill="#DBE4EE"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M46 63C46 69.0751 41.0751 74 35 74C35 74 41.2857 69.0751 41.2857 63C41.2857 56.9249 35 52 35 52C41.0751 52 46 56.9249 46 63Z"
            fill="white"
        />
        <path
            d="M42.7085 61.6856L40.6527 61.3496C40.5323 60.937 40.3678 60.5405 40.1618 60.1652L41.3619 58.455C41.459 58.3169 41.4423 58.1287 41.323 58.009L39.9702 56.657C39.8495 56.5367 39.6595 56.521 39.5211 56.6209L37.8364 57.8317C37.4576 57.6223 37.0576 57.456 36.6426 57.3353L36.2839 55.288C36.2547 55.1217 36.1104 55 35.9413 55H34.0281C33.8576 55 33.7122 55.1235 33.6848 55.2918L33.3522 57.328C32.9348 57.448 32.534 57.6125 32.1566 57.8191L30.4765 56.6191C30.3377 56.52 30.1488 56.536 30.0281 56.656L28.676 58.008C28.5567 58.1273 28.54 58.3151 28.637 58.4532L29.8194 60.1447C29.6089 60.5256 29.4413 60.9287 29.3192 61.3482L27.2908 61.6859C27.1231 61.7137 27 61.8591 27 62.0289V63.9419C27 64.1106 27.1211 64.255 27.287 64.2845L29.3153 64.6442C29.4367 65.0626 29.6044 65.4657 29.8155 65.8477L28.6186 67.5217C28.5198 67.6598 28.5354 67.8494 28.6554 67.9701L30.0079 69.3235C30.1272 69.4428 30.3154 69.4595 30.4535 69.3624L32.1476 68.176C32.5278 68.385 32.9296 68.551 33.3459 68.6713L33.6855 70.7099C33.7129 70.8772 33.858 71 34.0281 71H35.9413C36.11 71 36.2544 70.879 36.2836 70.713L36.6471 68.6643C37.0642 68.5416 37.4639 68.3746 37.8402 68.1652L39.5465 69.3621C39.6849 69.4598 39.8728 69.4428 39.9924 69.3235L41.3449 67.9701C41.4653 67.8494 41.4809 67.6591 41.3811 67.5207L40.1643 65.8313C40.3706 65.4557 40.5344 65.0584 40.6537 64.6459L42.7123 64.2845C42.8789 64.2553 43 64.1106 43 63.9419V62.0289C43.0003 61.8584 42.8769 61.713 42.7085 61.6856ZM35 65.4348C33.6552 65.4348 32.565 64.3447 32.565 63C32.565 61.6553 33.6552 60.5652 35 60.5652C36.3448 60.5652 37.435 61.6553 37.435 63C37.435 64.3447 36.3448 65.4348 35 65.4348Z"
            fill="#333F50"
        />
    </svg>
);

export default AdminUser;
